import React, { useEffect, useState } from "react";
import "../../styles/desktop/AlarmeModal.css";
import LegendaCaixadagua from "./LegendaCaixaDagua/legendaCaixaDagua";
import Alarmes from "./AlarmeObjeto/Alarmes";
import { getAlarmes } from "../../API/getAlarmes";

const AlarmeModal = () => {
  const [alarmes, setAlarmes] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getAlarmes();
        setAlarmes(data); // Configura os alarmes com os dados recebidos
        console.log("Alarmes: ", data);
      } catch (error) {
        console.error("Erro ao buscar alarmes:", error);
      }
    };

    fetchData();

    const intervalId = setInterval(fetchData, 8200);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <>
      <div className="CampoAlarme">
        <h1 className="tituloCampo4">Alarmes</h1>
        <div className="campoLegendaCaixadagua">
          <LegendaCaixadagua alarmes={alarmes} />
        </div>
        <div className="campoAlarmes">
          <Alarmes alarmes={alarmes} />
        </div>
      </div>
    </>
  );
};

export default AlarmeModal;
